import React, { useContext, useEffect } from "react";
import { AppbarContentContext } from "../../../../commons/routing/appbar/AppbarContentProvider";
import { useLocation } from "react-router-dom";
import LoadingProgressIndication from "../../../../commons/elements/progress/loading/LoadingProgressIndication";
import { Redirect } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import associationStructure from "../../../../commons/associationStructure/associationStructure";
import useLoadNextScoredScene from "../../util/useLoadNextScoredScene";

/*
   Redirect page for the game session, it loads the next scene and sends you to a page
   with a game session of the corresponding type.
 */

const GameSessionRedirect = () => {
    const { setCurrentAppbarContent } = useContext(AppbarContentContext);
    const intl = useIntl();
    const location = useLocation();

    const { scene, loadingScene } = useLoadNextScoredScene(
        location.state.playlistId,
        location.state.courseId,
        location.state.scoredSceneId,
        location.state.isReplay
    );

    // Setting the appbar content
    useEffect(() => {
        setCurrentAppbarContent({
            header: (
                <FormattedMessage
                    id={"app.game.session.redirect.appbar.header"}
                    defaultMessage={"Game Session"}
                />
            ),
            description: (
                <FormattedMessage
                    id={"app.game.session.redirect.appbar.description"}
                    defaultMessage={"Your session is loading..."}
                />
            ),
            actions: <></>,
        });
    }, []);

    const labSession = "lab-session";
    const regularSession = "regular";

    if (loadingScene) {
        return (
            <LoadingProgressIndication
                text={intl.formatMessage({
                    id: "app.game.loading.scene",
                    defaultMessage: "Loading scene...",
                })}
            />
        );
    }

    console.log(scene);
    const associationDisciplines =
        associationStructure[scene.video.basics.association].disciplines;

    function determineSessionProperties() {
        for (let i = 0; i < associationDisciplines.length; i++) {
            if (scene.video.basics.discipline === associationDisciplines[i].name) {
                return {
                    sessionMode: associationDisciplines[i].mode,
                    sessionPoints: associationDisciplines[i].validScores.filter(
                        (score) => !isNaN(score.id) && score.id !== "0"
                    ),
                    sessionPenalties: associationDisciplines[i].validScores.filter(
                        (score) => isNaN(score.id)
                    ),
                };
            }
        }
    }

    const sessionProperties = determineSessionProperties();

    // Condense the current scene info to an object and enrich it with some information
    const gameSessionInfo = {
        key: scene.key,
        courseId: location.state.courseId,
        playlistId: location.state.playlistId,
        association: scene.video.basics.association,
        id: scene.video.vimeo.playerEmbedUrl,
        discipline: scene.video.basics.discipline,
        ageGroup: scene.video.basics.ageGroup,
        gender: scene.video.basics.gender,
        blurring: scene.basics.blurring,
        sceneEnd: scene.basics.sceneEnd,
        sceneStart: scene.basics.sceneStart,
        scoreDefinitions: scene.scoreDefinitions,
        athleteLeftPosition: scene.basics.athleteLeftPosition,
        trailingPeriod: scene.basics.trailingPeriod,
        sessionProperties: sessionProperties,
        feedbackMode: location.state.feedbackMode,
        isReplay: location.state.isReplay,
        index: scene.index,
        endRun: scene.endRun,
    };

    const playlistInfo = {
        playlistName: location.state.playlistName,
        scoredSceneCount: location.state.scoredSceneCount,
        currentScene: scene.index,
    };

    return (
        <Redirect
            to={{
                pathname: "/game/session/" + gameSessionInfo.key + "/play",
                state: { gameSessionInfo: gameSessionInfo, playlistInfo: playlistInfo },
            }}
        />
    );
};

export default GameSessionRedirect;
